<template>
  <div class="cases-container">
    <div class="cases">
      <!-- case 按钮 -->
      <div v-for="(item, index) in cases" :key="index" class="case case-btn"
        :class="{ active: item.value === selectedValue }" @click="selectTab(index)">
        <div class="label-wrap">
          <img :src="item.image" alt="box" />
          <span class="mle">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
export default {
  name: "CustomCasesTabs",
  mixins: [responsiveMixin],
  props: {
    cases: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: [Number, String],
      default: "",
    }
  },
  data() {
    return {
      selectedValue: this.value, // 当前选中的
    };
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    selectTab(index) {
      this.selectedValue = this.cases[index].value;
      this.$emit("input", this.selectedValue);
      this.$emit("change", this.cases[index]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
